import { application } from "../application"

import ListGridController from "./list_grid_controller";
application.register("list-grid", ListGridController);
import DarkModeController from "./dark_mode_controller";
application.register("dark-mode", DarkModeController);
import MrrChartController from "./mrr_chart_controller";
application.register("mrr-chart", MrrChartController);
import PricingController from "./pricing_controller";
application.register("pricing", PricingController);
import RevenueChartController from "./revenue_chart_controller";
application.register("revenue-chart", RevenueChartController);
import SelectAllController from "./select_all_controller";
application.register("select-all", SelectAllController);
import BarChartController from "./bar_chart_controller";
application.register("bar-chart", BarChartController);
import AreaChartController from "./area_chart_controller";
application.register("area-chart", AreaChartController);

import {
  RailsuiClipboard,
  RailsuiCountUp,
  RailsuiDateRangePicker,
  RailsuiDropdown,
  RailsuiModal,
  RailsuiRange,
  RailsuiSelectAll,
  RailsuiTabs,
  RailsuiToast,
  RailsuiToggle,
  RailsuiTooltip
} from 'railsui-stimulus'

application.register('railsui-clipboard', RailsuiClipboard)
application.register('railsui-count-up', RailsuiCountUp)
application.register('railsui-date-range-picker', RailsuiDateRangePicker)
application.register('railsui-dropdown', RailsuiDropdown)
application.register('railsui-modal', RailsuiModal)
application.register('railsui-range', RailsuiRange)
application.register('railsui-select-all', RailsuiSelectAll)
application.register('railsui-tabs', RailsuiTabs)
application.register('railsui-toast', RailsuiToast)
application.register('railsui-toggle', RailsuiToggle)
application.register('railsui-tooltip', RailsuiTooltip)
